import { Component, Ref, Vue, Watch, Prop } from 'vue-property-decorator'
import Inquiry from '@/inquiries/models/inquiry'
import inquiriesService from '@/inquiries/services/inquiries-service'
import InquiriesFilterRequest from '@/inquiries/models/inquiries-filter-request'
import { InquiryState } from '@/inquiries/models/inquiry-state'
import InquiryDialog from '@/inquiries/components/inquiry-dialog/inquiry-dialog'
@Component
export default class InquiriesClosed extends Vue {
  @Ref()
  private dialog!: InquiryDialog

  private loading: boolean = false
  private inquiries: Inquiry[] = []
  private filter = new InquiriesFilterRequest()
  private reactivateDialog: boolean = false

  private async findAsync() {
    this.loading = true
    // Workaround for empty radiusOfInterest.
    if (!this.filter.radiusOfInterest) {
      this.filter.radiusOfInterest = 0
    }
    const response = await inquiriesService.findAllClosedAsync(this.filter)
    this.inquiries = response.items
    this.filter.pagination.totalItems = response.totalItems
    this.loading = false
  }

  private openCopy(inquiry: Inquiry) {
    this.dialog.openNew(Inquiry.copy(inquiry))
  }

  private async create(inquiry: Inquiry) {
    await inquiriesService.saveAsync(inquiry)
    await this.findAsync()
  }

  private async update(inquiry: Inquiry) {
    await inquiriesService.updateAsync(inquiry)
    await this.findAsync()
  }

  private async reactivate(inquiry: Inquiry) {
    if (inquiry.expiryDate && new Date(inquiry.expiryDate) < new Date()) {
      this.reactivateDialog = true
      return
    }
    await inquiriesService.reactivateAsync(inquiry)
    await this.findAsync()
  }

  private async remove(inquiry: Inquiry) {
    if (confirm('Wirklich löschen?')) {
      await inquiriesService.removeAsync(inquiry.id)
      await this.findAsync()
    }
  }

  private async mounted() {
    this.filter.creatorId = null
    this.filter.takerId = null
    this.filter.state = InquiryState.Closed
    this.filter.radiusOfInterest = 0
    await this.findAsync()
  }
}
